
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { parseJwt } from './services/jwt';
import { clearUserCredentials } from './actions/application';
import { lexonCredentialsClear } from './actions/lexon';
import { currentUserCredentialsClear } from './actions/user';
import { removeState } from './services/state';

// mapStateToProps
const useAppState = () => {
  const application = useSelector(state => state.application);
  const lexon = useSelector(state => state.lexon);
  return { application, lexon };
};

// mapDispatchToProps
const useAppDispatch = () => {
  const dispatch = useDispatch();
  return {
    logout: () => {
      dispatch(clearUserCredentials());
      dispatch(lexonCredentialsClear());
      dispatch(currentUserCredentialsClear());
    }
  };
};


const PrivateRoute = ({ children }) => {
  const { application } = useAppState();
  const { logout } = useAppDispatch();
  const location = useLocation();

  if (application.user && application.user.credentials) {
    const search = location.search;
    const appConnectEmail = new URLSearchParams(search).get('appConnectMail');
    const appConnectParse = appConnectEmail && parseJwt(appConnectEmail);
    if (appConnectParse) {
      removeState();
      logout();
      return <Navigate to={{ pathname: '/login', search: window.location.search }} replace />;
    }
    // Renderiza el contenido protegido
    return children ? children : <Outlet />;
  }
  // Si no está autenticado, redirige a login
  return <Navigate to={{ pathname: '/login', search: window.location.search }} replace />;
};

export default PrivateRoute;
